@let stars = this.stars();
<div class="stars">
  @for (_star of Array(stars.full); track $index) {
    <div [innerHTML]="starFull"></div>
  }
  @if (stars.half) {
    <div [innerHTML]="starHalf"></div>
  }
  @for (_star of Array(stars.empty); track $index) {
    <div [innerHTML]="starEmpty"></div>
  }
</div>
